module.exports = __webpack_public_path__ + "static/img/linux.d5db4600.png";